module.exports = __webpack_public_path__ + "static/media/politica_licencamiento.69f52099.pdf";